import { Fab } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import DeleteDialog from "../../DeleteDialog";
import FormDialogCity from "../../FormDialogCity";
import TableCity from "../../TableCity";
import { City } from "../../../interfaces/City";
import { cityActions, citySelectors } from "../../../redux";
import { loadAllCity } from "../../../redux/city/sagaActions";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 440,
  },
  actionButtons: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}));

function CityPage() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [selectedCity, setSelectedCity] = useState<City | undefined>();
  const [deleteId, setDeleteId] = useState("");
  const [cityDialogOpen, setCityDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState<boolean>(false);

  useEffect(() => {
    dispatch(loadAllCity({}));
  }, [dispatch]);

  const handleCloseDeleteDialogOpen = () => {
    dispatch(cityActions.clear("deletedCity"));
    dispatch(cityActions.loadAllCity({}));
    setIsDeleteDialogOpen(false);
  };

  const handleCreateNewCity = () => {
    setSelectedCity(undefined);
    setCityDialogOpen(true);
  };

  const handleDeleteDialogOpen = (id: string) => {
    setDeleteId(id);
    setIsDeleteDialogOpen(true);
  };

  const handleEditCity = (city: City | undefined) => {
    setSelectedCity(city);
    setCityDialogOpen(true);
  };

  return (
    <>
      <div className={classes.actionButtons}>
        <Fab onClick={handleCreateNewCity} variant="extended" color="primary">
          <AddIcon></AddIcon>Crea nuova città
        </Fab>
      </div>

      <TableCity
        onDeleteCity={handleDeleteDialogOpen}
        onEditCity={handleEditCity}
      ></TableCity>
      {selectedCity ? (
        <FormDialogCity
          cityToUpdate={selectedCity}
          isOpen={cityDialogOpen}
          onClose={() => {
            console.log("here");
            setSelectedCity(undefined);
            setCityDialogOpen(false);
          }}
        />
      ) : (
        <FormDialogCity
          isOpen={cityDialogOpen}
          onClose={() => {
            setSelectedCity(undefined);
            setCityDialogOpen(false);
          }}
        />
      )}
      <DeleteDialog
        isOpen={isDeleteDialogOpen}
        onClose={handleCloseDeleteDialogOpen}
        deleteAction={cityActions.deleteCityById}
        selector={citySelectors.getDeletedCity}
        id={deleteId}
      />
    </>
  );
}

export default CityPage;
